module.exports = __webpack_public_path__ + "img/chevron-down.1bf49f67.svg";